<mat-sidenav-container color="primary">
    <mat-sidenav-content>
        <div style="margin-left: 30px;margin-right: 30px;" fxLayout="column" class="mat-elevation-z1">
            <div>
                <mat-toolbar style="margin-top: 10px;" color="primary" fxFlex="100%" fxLayout="column">
                    <mat-toolbar-row fxLayoutAlign="center" fxLayout="column" fxFlex="100%">
                        <h2 fxFlexAlign="center">Authorization</h2>
                    </mat-toolbar-row>
                    <mat-toolbar-row fxLayout="row" fxFlex="100%">
                        <button mat-button [disabled]="disabled()" matTooltip="Clear"
                            (click)="clearSignatureButtonClicked()">Clear Signature</button>
                    </mat-toolbar-row>
                </mat-toolbar>
            </div>
            <div style="padding-left: 20px; padding-top: 20px;" [innerHTML]="html">

            </div>
            <div style="width: 100%;text-align: center;">
                <mat-checkbox (change)="authorizationChanged($event)">I Authorize
                </mat-checkbox>
                <div>Please sign here using mouse</div>
                <signature-pad  [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
                    (onEndEvent)="drawComplete()"></signature-pad>
            </div>
            <div style="padding: 20px;">
                <div fxFlex></div>
                <button [disabled]="!authorize || disableSubmitButton || !signaturePresent " mat-raised-button color="primary"
                    (click)="saveButtonClicked()">Submit</button>
            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>

